import { product, productGroup, cart } from "./fragments";

export const productWithGroup = `
query productWithGroup($id: ID!) @inContext(country: ${window.Shopify.country}) {
  product(id: $id) {
    ${product}
    ${productGroup}
  }
}
`;

export const storefrontCartAdditionalData = `
  query storefrontCart($id: ID!) {
    cart(id: $id) {
      id
      lines(first: 100) {
        nodes {
          id
          discountAllocations {
            ... on CartAutomaticDiscountAllocation {
              title
              discountedAmount {
                currencyCode
                amount
              }
            }
          }
        }
      }
    }
  }
`;

export const cartDeliveryAddressesAdd = `
  mutation CartDeliveryAddressesAdd($id: ID!, $addresses: [CartSelectableAddressInput!]!) {
    cartDeliveryAddressesAdd(cartId: $id, addresses: $addresses) {
      userErrors {
        message
        code
        field
      }
      warnings {
        message
        code
        target
      }
      cart {
        ${cart}
      }
    }
  }
`;

export const storefrontCart = `
  query storefrontCart($id: ID!) {
    cart(id: $id) {
      ${cart}
    }
  }
`;

export const cartWithDeliveryGroups = `
  query cartWithDeliveryGroups($id: ID!) {
    cart(id: $id) {
      ${cart}
      ... DeliveryGroups @defer
    }
  }

  fragment DeliveryGroups on Cart {
    deliveryGroups(first: 10, withCarrierRates: true) {
      edges {
        node {
          id
          deliveryOptions {
            title
            handle
            estimatedCost {
              amount
              currencyCode
            }
          }
          selectedDeliveryOption {
            title
            handle
            estimatedCost {
              amount
              currencyCode
            }
          }
        }
      }
    }
  }
`;

export const cartDeliveryAddressesUpdate = `
mutation CartDeliveryAddressesUpdate($id: ID!, $addresses: [CartSelectableAddressUpdateInput!]!) {
  cartDeliveryAddressesUpdate(cartId: $id, addresses: $addresses) {
    userErrors {
      message
      code
      field
    }
    warnings {
      message
      code
      target
    }
    cart {
      ${cart}
    }
  }
}
`;
